import styled from "styled-components";

export const ViewContainer = styled.div`
  min-height: 50vh;
  &.card {
    height: 100%;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;

  .rulesTabs {
    border-bottom: #cccccc59 2px solid;
    padding: 0 20px;

    button {
      font-size: 12px;
      color: #999999;

      &.Mui-selected {
        color: var(--text-primary);
      }
    }
  }
  div[role="tabpanel"] {
    padding: 0px 20px 20px;
  }
`;

export const TabContent = styled.div`
  padding: 20px;
`;

export const RulesTreeWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const SubMenuWrapper = styled.div`
  margin: 15px 8px 10px 9px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > div,
  > button {
    margin-bottom: 10px;
  }
`;

export const SelectWrapper = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  color: var(--Text-Primary);
  margin: 0 10px;

  .selectProfile {
    min-width: 100px;
    > div {
      margin: 0 5px;
      border: 1px solid #999;
    }
  }
`;